module.exports = {
    "page.import.historyBox.col.status": "স্ট্যাটাস",
    "page.im.setting.init.confirm": "একবার বরাদ্দ হলে প্রাথমিক চ্যাট অ্যাকাউন্টটি এডিট অথবা ডিলেট করা যাবে না। দয়া করে সঠিক অ্যাকাউন্ট জমার বিষয়টি নিশ্চিত করুন",
    "page.import.importBox.templateTitle": "টেমপ্লেট ডাউনলোড করুন",
    "page.im.window.label.message": "চ্যাট",
    "page.import.historyBox.col.filename": "ফাইলের নাম",
    "page.im.window.prdSearchPlaceholder": "দয়া করে পণ্যের টাইটেল প্রদান করুন",
    "page.im.setting.title": "চ্যাট সেটিং",
    "page.im.window.view": "দেখুন",
    "page.im.setting.imForm.to": "দিকে",
    "page.im.setting.btn.remove": "সরান",
    "page.import.historyBox.col.user": "ব্যবহারকারী",
    "page.import.importBox.importModeText": "মুড ইমপোর্ট করুন",
    "page.im.window.label.status": "স্ট্যাটাস",
    "page.im.setting.btn.createUser": "একটি নতুন পূর্ণ এক্সেস ইউজার তৈরি করুন",
    "page.import.footer.button.done": "সম্পন্ন",
    "page.im.window.draft": "ড্রাফট",
    "page.im.window.date.yesterday": "গতকাল",
    "page.im.setting.imForm.from": "থেকে",
    "page.im.window.process.resend": "পুনরায় পাঠান",
    "page.import.footer.button.another": "অন্যটি ইমপোর্ট করুন",
    "page.im.setting.assignment.title": "আপনার প্রাথমিক চ্যাট অ্যাকাউন্ট বরাদ্দ করুন",
    "page.import.historyBox.link.download": "ডাউনলোড",
    "page.im.window.label.loading": "লোডিং",
    "page.im.window.label.total": "মোট",
    "page.im.setting.btn.addUser": "ব্যবহারকারীকে যুক্ত করুন",
    "page.import.title": "ইমপোর্ট করুন",
    "page.import.importBox.footerTips": "বাল্ক আপলোডের মাধ্যমে আপডেট করা বর্ণনাটি লোরিকিতের ভিতরে দৃশ্যমান হবে না। যেমন বিবরণ দেখতে এক্সেল ফাইল মধ্যে পণ্য ডাউনলোড করুন",
    "page.import.historyBox.processed.table.col.failure": "ব্যর্থতা",
    "page.im.setting.assignment.placeholder": "ইমেইল, ব্যবহারকারীর নাম",
    "page.import.historyBox.processed.table.col.sucess": "সফল",
    "page.im.window.label.totalItems": "মোট আইটেম",
    "page.import.historyBox.feedback.success": "আপনার ইমপোর্ট সম্পন্ন হয়েছে",
    "page.im.setting.tab3": "সংক্রিয় রিপ্লাই",
    "page.import.import": "ইমপোর্ট",
    "page.import.importBox.infos.2": "উল্লেখ্যঃ এক্সেল ফাইলে কোন ফর্মুলা বা রেফারেন্স থাকতে পারে না",
    "page.im.window.label.order": "অর্ডার",
    "page.im.window.label.refresh": "রিফ্রেশ করুন",
    "page.import.tab.import": "ইমপোর্ট করুন",
    "page.im.setting.action": "শাওবাই টেস্ট",
    "page.im.setting.assignment.subTitle": "দয়া করে আপনার চ্যাট অ্যাকাউন্টের দায়িত্বে থাকা লগইনটি বরাদ্দ করুন। আপনার একাধিক ব্যবহারকারী থাকলে আপনার সমস্ত চ্যাটগুলি শুধুমাত্র একজন দেখতে পারবেন। উল্লেখ্য একবার জমা দেওয়া হলে এই অ্যাকাউন্টটি আর পরিবর্তন করা যাবে না",
    "page.import.historyBox.col.action": "পদক্ষেপ",
    "page.import.importBox.infos.3": "এনকোডিং ফরম্যাটঃ ইউটিএফ-৮, সেপারেটরঃ সেমিকোলন",
    "page.im.setting.btn.clear": "নির্বাচিত ক্লিয়ার করুন",
    "page.import.historyBox.col.progress": "উন্নতি",
    "page.im.window.unread": "অপঠিত",
    "page.import.tab.template": "টেমপ্লেটের কার্যকলাপ",
    "page.im.window.units": "ইউনিট",
    "page.im.window.oversize": "আপলোড করার জন্য ফাইলটি খুব বড় (৫০ এমবি থেকে ছোট)",
    "page.import.importBox.infos.1": "পণ্য তৈরি বা আপলোড করার জন্য আপনি ছিএসভি ফাইলগুলি ব্যবহার করতে পারেন (.csv) অথবা এমএস এক্সেল ডকুমেন্ট (.xlsx)।",
    "page.import.importBox.importButton": "ফাইল আপলোড করুন",
    "page.im.setting.confirm": "আপনি কি এই গ্রুপ থেকে ব্যবহারকারীকে সরাতে নিশ্চিত",
    "page.import.tab.history": "কার্যকলাপ ইমপোর্ট করুন",
    "page.im.setting.current.desc": "সব নির্বাচিত পেজগুলো থেকে",
    "page.im.window.label.emptyMessage": "কোন বার্তা গৃহিত হয়নি",
    "page.im.setting.tab2": "দ্রুত রিপ্লাই",
    "page.import.historyBox.col.created": "তৈরী",
    "page.im.setting.btn.selectAll": "সব পেজগুলো থেকে",
    "page.im.window.orderSearchPlaceholder": "দয়া করে অর্ডারের সংখ্যা প্রদান করুন",
    "page.im.window.disconnection": "নেটওয়ার্ক বিচ্যুতি",
    "page.import.historyBox.search.user": "ব্যবহারকারী",
    "page.im.window.label.emptyList": "ওহো না, ক্রেতা আপনার শপ থেকে এখনো কোন কিছু ক্রয় করেনি",
    "page.im.window.read": "পড়ুন",
    "page.import.historyBox.search.action": "পদক্ষেপ",
    "page.im.setting.tab1": "ব্যবহারকারী ব্যবস্থাপনা",
    "page.import.historyBox.search.filename": "ফাইলের নাম",
    "page.import.historyBox.feedback.failed": "আপনার ইমপোর্ট ব্যর্থ হয়েছে",
    "page.im.window.label.orderTime": "অর্ডারের সময়",
    "page.im.setting.management.title": "কাস্টমার সাপোর্ট",
    "page.import.historyBox.link.downloadErrorReport": "এরর রিপোর্ট ডাউনলোড করুন",
    "page.import.historyBox.col.type": "ফাইলের নাম",
    "page.im.window.send": "পাঠান",
    "page.import.historyBox.processed.table.col.warning": "সতর্কতা",
    "page.import.historyBox.col.processed": "প্রক্রিয়াজাত করা"
};